

<template>
  <section>
    <PagesPath
    :pathTitle="'ارتباط با ثریا مارکت'"
        :pathTitle1="'تماس با ما '"
        :pathTo1="'/contact'"
      ></PagesPath>
    <section
      class="container   content "
    >
      <article class="captionForm">
        <h3 class="fontsize-xheavy text-color-theme">ما همیشه مشتاق شنیدن از شما هستیم!</h3>
        <div class="mt-5 mr-3 mr-md-0">
          <div>
            <h5 class="text-color-theme fontsize-heavy font-weight-bold">آدرس :</h5>
            <p class="text-color-black">{{ content.settings.site.address }}</p>
          </div>
          <div>
            <h5 class="text-color-theme fontsize-heavy font-weight-bold">ثبت سریع سفارش :</h5>
            <p class="text-color-black">{{ content.settings.site.mobile }}</p>
          </div>
          <div>
            <h5 class="text-color-theme fontsize-heavy font-weight-bold">پست الکترونیک :</h5>
            <p class="text-color-black">{{
                  content.settings.site.email
                }}</p>
          </div>
        </div>
      </article>
      <article >
        <form
          action=""
          class="d-flex flex-column bg-white py-5 px-4 rounded form"
        >
          <h5 class="text-color-theme fontsize-xheavy font-weight-bold">در تماس باشید</h5>
          <p>برای ارتباط این فرم را پرکنید</p>
          <input
            class="my-3 border-bottom py-1"
                  ref="name"
                  type="text"
            placeholder="نام و نام خانوادگی شما "
            id=""
          />
          <input
                  class="my-3 border-bottom py-1"
                  ref="phone"
                  :type="mediaQueries.mobileSize == true ? 'tel' : 'number'"
                  placeholder="شماره تماس"
                />
          <input
            class="my-3 border-bottom py-1"
                  ref="email"
                  type="email"
                  name="email"
            placeholder="ایمیل خود را وارد کنید *"
            id=""
          />
          <input
            class="my-3 border-bottom py-1"
                  ref="subject"
                  type="text"
            placeholder="موضوع"
            id=""
          />
          <textarea
            class="my-3 border-bottom py-1"
            name=""
            id=""
                            ref="body"
            placeholder="پیغام تو"
            cols="20"
            rows="1"
          ></textarea>
          <div class="w-100">
            <button class="custom-btn float-left"   :class="{ disabled: disabled }"
                  @click.prevent="sendForm"
                  type="submit"
                  value="ارسال پیام" > ارسال</button>
          </div>
          
        </form>
      </article>
    </section>
    <section class="w-100 map">
      <iframe
       src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3530.6099006866853!2d54.0062657!3d27.7601758!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e515564ec10c5fb%3A0x8d931b9b8e5e2ee4!2z2LHZiNi62YYg2YXYp9ix2qnYqiDYq9ix24zYpw!5e0!3m2!1sen!2s!4v1723441971609!5m2!1sen!2s" 
       class="w-100"
       width="600" 
       height="450" 
       style="border:0;" 
       allowfullscreen="" 
       loading="lazy" 
       referrerpolicy="no-referrer-when-downgrade">
      </iframe>
    </section>
  </section>
</template>

<style scoped>
.content{

  display: flex;
  justify-content: center;
  margin: 30px auto;
  gap: 50px;
}
.form {
  width: 350px;
  z-index: 10;
  position: relative;
}
.map{
  transform: translateY(-100px);
  z-index: 1;
}
@media screen and ( max-width: 768px) {
  .content{
  display: flex;
  flex-direction: column !important;

  margin: 30px auto;
  gap: 50px;
}
}

/* برداشتن دکمه های بالا پایین برای ورود عدد */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
#answerBox {
  padding: 5px !important;
  width: 70px;
  border-radius: 4px;
}
#contactCheckAndSubmit {
  display: flex;
  flex-wrap: wrap;
}
.disabled {
  pointer-events: none;
  opacity: 0.5;
}
.inputError {
  border: 1px solid red !important;
  background: #efe1e4;
}
span.notLoginMassege {
  font-size: 17px;
  background-color: #cccccc3f;
  width: 100%;
  padding: 1rem;
  border-radius: 5px;
  margin-top: 1rem;
  display: table;
}
.faqs details summary div {
  background: var(--color-themepinky);
  width: 24px;
  display: flex;
  border-radius: 50%;
  justify-content: center;
  height: 24px;
  align-items: center;
  color: white;
}
.faqs details summary {
  display: flex;
  gap: 12px;
  align-items: center;
}
.faqs details[open] summary .o {
  display: block;
}
.faqs details[open] summary .c {
  display: none;
}
.faqs details summary .o {
  display: none;
}
.faqs details {
  margin: 16px;
}
.faqs p {
  margin-top: 24px;
  margin-right: 5%;
  padding: 12px;
  box-shadow: 0 0 5px #eb6fa7;
}
.send-message {
  border-radius: 15px;
}
@media screen and (max-width: 578px) {
  .security-question {
    margin-bottom: 1.5rem;
  }
}
</style> 


<script>
import PagesPath from "@/parts/Front/components/PagesPath";
import ZTwoArrowSvg from "../components/shared/ZTwoArrowSvg";
import SocialNetworks from "../components/shared/SocialNetworks";
export default {
  name: "Contact",
  inject: ["mediaQueries"],
  components: {
    SocialNetworks,
    ZTwoArrowSvg,
    PagesPath,
  },
  data() {
    return {
      code: null,
      question: null,
      disabled: false,
    };
  },
  computed: {
    faqs() {
      return this.$store.getters["front/getFaqList"];
    },
    // ront/getAllFaqListFromServer

    // دریافت محتوای درخواست هوم
    content() {
      return this.$store.getters["front/getHomeData"];
    },
    loading() {
      return this.$store.getters["front/getHomeDataStatus"];
    },
    user() {
      if (
        this.$store.getters["front/getHomeData"] != null &&
        this.$store.getters["front/getHomeData"].user.user != null
      ) {
        return this.$store.getters["front/getHomeData"].user.user;
      } else {
        return null;
      }
    },
    isLogin() {
      return this.$store.getters["front/getLoginStatus"];
    },
  },
  mounted() {
    if (!this.faqs) {
      this.$store.dispatch("front/getAllFaqListFromServer");
    }
    this.$axios.get("all/contacts/create").then((response) => {
      this.code = response.data.data.name;
      this.question = response.data.data.message;
    });
  },
  methods: {
    sendForm() {
      // if (this.$refs.name.value.length < 2) {
      //   this.$refs.name.classList.add("inputError");
      // return   window.swal({
      //     title: "وارد کردن  نام الزامی است",
      //     text: "نام باید شامل دو کارکتر یا بیشتر باشد",
      //     icon: "warning",

      //     showConfirmButton: true,
      //     dangerMode: true,
      //     button: "متوجه شدم",
      //   }).then(()=>{

      //     this.$refs.name.focus();
      //   })

      // } else {
      //   this.$refs.name.classList.remove("inputError");
      // }
      // if (this.$refs.phone.value.length != 11) {
      //   this.$refs.phone.classList.add("inputError");
      //  return  window.swal({
      //     title: "ورود کردن شماره تماس الزامی است",
      //     text: "شماره تماس شامل 11 رقم است",
      //     icon: "warning",

      //     showConfirmButton: true,
      //     dangerMode: true,
      //               button: "متوجه شدم",

      //   }).then(()=>{

      //     this.$refs.phone.focus();
      //   })

      // } else {
      //   this.$refs.phone.classList.remove("inputError");
      // }
      if (this.$refs.subject.value.length < 3) {
        this.$refs.subject.classList.add("inputError");
        return window
          .swal({
            title: "موضوع ارتباط را به درستی وارد کنید",
            icon: "warning",

            showConfirmButton: true,
            dangerMode: true,
            button: "متوجه شدم",
          })
          .then(() => {
            this.$refs.subject.focus();
          });
      } else {
        this.$refs.subject.classList.remove("inputError");
      }
      if (this.$refs.body.value.length < 3) {
        this.$refs.body.classList.add("inputError");
        return window
          .swal({
            title: "متن پیام خود را وارد کنید",
            text: "این متن نباید از 10 کارکتر کمتر باشد",
            icon: "warning",

            showConfirmButton: true,
            dangerMode: true,
            button: "متوجه شدم",
          })
          .then(() => {
            this.$refs.body.focus();
          });
      } else {
        this.$refs.body.classList.remove("inputError");
      }
      if (this.$refs.answer.value.length < 1) {
        this.$refs.answer.classList.add("inputError");
        return window
          .swal({
            title: "پاسخ سوال امنیتی را وارد کنید",
            icon: "warning",

            showConfirmButton: true,
            dangerMode: true,
            button: "متوجه شدم",
          })
          .then(() => {
            this.$refs.answer.focus();
          });
      } else {
        this.$refs.answer.classList.remove("inputError");
      }
      const formData = new FormData();
      // formData.append("name", this.$refs.name.value);
      // formData.append("phone_number", this.$refs.phone.value);
      formData.append("subject", this.$refs.subject.value);
      formData.append("body", this.$refs.body.value);
      formData.append("customer_id", this.user.id);
      formData.append("" + this.code, this.$refs.answer.value);
      this.disabled = true;
      this.$axios
        .post("/customer/contacts", formData)
        .then((res) => {
          this.disabled = false;
          // this.$refs.name.value = null;
          // this.$refs.phone.value = null;
          this.$refs.subject.value = null;
          this.$refs.body.value = null;
          this.$refs.answer.value = null;
          window.swal({
            title: "ارتباط با فروشگاه ثریا برقرار شد",
            text: "پیام شما در سیستم ما درج و به زودی پاسخ آنرا دریافت خواهید کرد باتشکر!",
            icon: "success",

            showConfirmButton: true,
            button: "متوجه شدم",
          });
        })
        .catch((err) => {
          this.disabled = false;
          window
            .swal({
              title: "پاسخ سوال امنیتی را  به درستی وارد نکرده اید",
              icon: "warning",

              showConfirmButton: true,
              dangerMode: true,
              button: "متوجه شدم",
            })
            .then(() => {
              this.$refs.answer.focus();
            });
        });
    },
  },
};
</script>

